import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { ComponentProperties, CrudType, IApplicationResponse,  ModulesBasedApiSuffix, prepareGetRequestHttpParams, RxjsService, PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes, SnackbarService, prepareRequiredHttpParams, getPDropdownData, onActionSubmittedUtil } from '@app/shared';
import { CrudService } from '@app/shared/services';
import { MomentService } from '@app/shared/services/moment.service';
import { InventoryModuleApiSuffixModels, INVENTORY_COMPONENT } from '@modules/inventory/shared';
import { DialogService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';

import { Store } from '@ngrx/store';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
@Component({
  selector: 'app-exclution-list',
  templateUrl: './exclution-list.component.html',
  styleUrls: ['./exclution-list.component.scss']
})
export class ExclutionListComponent extends PrimeNgTableVariablesModel implements OnInit {
  observableResponse;
  componentProperties = new ComponentProperties();
  row: any = {}
  showFilterForm: boolean = false;
  exclusionFilterForm: FormGroup;
  warehouseList: any = [];
  startTodayDate = 0;
  otherParams;
  constructor(private snackbarService: SnackbarService,  private crudService: CrudService, private activatedRoute: ActivatedRoute, public dialogService: DialogService, private router: Router,
    private store: Store<AppState>, private momentService: MomentService,
    private rxjsService: RxjsService, private _fb: FormBuilder) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Exclusion Report",
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '' }, { displayName: 'Ordering' }, { displayName: 'Exclusion Report' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Exclusion Report',
            dataKey: 'exclusionListId',
            enableBreadCrumb: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            rowExpantableIndex: 0,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            enableAction: true,
            shouldShowFilterActionBtn: true,
            enablePrintBtn: true,
            printTitle: 'ExClusion Report',
            printSection: 'print-section0',
            cursorSecondLinkIndex: 1,
            columns: [{ field: 'exclusionListNumber', header: 'Exclusion ID', width: '200px' },
            { field: 'requisitionNumber', header: 'Requisition ID', width: '200px' },
            { field: 'warehouseName', header: 'Warehouse', width: '200px' },
            { field: 'storageLocationName', header: 'Storage Location', width: '200px' },
            { field: 'createdDate', header: 'Generated Date', width: '200px',isDateTime:true }],
            apiSuffixModel: InventoryModuleApiSuffixModels.EXCLUSION_LIST,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
            enableExportBtn: true,
            ebableFilterActionBtn: true
          }
        ]
      }
    }
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.selectedTabIndex = (Object.keys(params['params']).length > 0) ? +params['params']['tab'] : 0;
      this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
      this.primengTableConfigProperties.breadCrumbItems[2].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    });
  }

  ngOnInit(): void {
    handleNgrxStoreData((response) => {
      let processData = processStoreData(response, this.primengTableConfigProperties, INVENTORY_COMPONENT.EXCLUSION_LIST);
      this.primengTableConfigProperties = processData.primengTableConfigProperties
      this.loggedInUserData = processData.loggedInUserData
    }, this.store);
    this.createExclusionFilterForm();
    this.getAllDataList()
    this.getRequiredListData();
  }

  onBreadCrumbClick(breadCrumbItem: object): void {
    if (breadCrumbItem.hasOwnProperty('queryParams')) {
      this.router.navigate([`${breadCrumbItem['relativeRouterUrl']}`],
        { queryParams: breadCrumbItem['queryParams'] })
    }
    else {
      this.router.navigateByUrl(`${breadCrumbItem['relativeRouterUrl']}`)
    }
  }
  getAllDataList(): void {
    forkJoin([this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_WAREHOUSE, prepareRequiredHttpParams({ userId: this.loggedInUserData?.userId }))
    ]).subscribe((response: IApplicationResponse[]) => {
      response.forEach((resp: IApplicationResponse, ix: number) => {
        if (resp.isSuccess && resp.statusCode === 200) {
          switch (ix) {
            case 0:
              this.warehouseList = getPDropdownData(resp.resources);
              break;
          }
        }
      })
      this.rxjsService.setGlobalLoaderProperty(false);
    })
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    otherParams = { ...otherParams, ...{ UserId: this.loggedInUserData?.userId } };
    this.otherParams = otherParams;
    let inventoryModuleApiSuffixModels: InventoryModuleApiSuffixModels;
    inventoryModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      inventoryModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.observableResponse = data.resources;
        this.dataList = this.observableResponse;
        this.totalRecords = data.totalCount;
      } else {
        this.observableResponse = null;
        this.dataList = this.observableResponse
        this.totalRecords = 0;
      }
    })
  }

  loadPaginationLazy(event) {
    let row = {}
    row['pageIndex'] = event.first / event.rows;
    row["pageSize"] = event.rows;
    row["sortOrderColumn"] = event.sortField;
    row["sortOrder"] = event.sortOrder == 1 ? 'ASC' : 'DESC';
    this.row = row;
    this.onCRUDRequested(CrudType.GET, this.row);
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.row = row;
        this.getRequiredListData(row["pageIndex"], row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.EXPORT:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canExport) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        let pageIndex = this.row && this.row["pageIndex"] ? this.row["pageIndex"] : 0;
        let pageSize = this.row && this.row["pageSize"] ? this.row["pageSize"] : 10;
        this.exportList(pageIndex, pageSize);
        // this.exportExcel();
        break;
      case CrudType.FILTER:
        this.showFilterForm = !this.showFilterForm;
        break;
      default:
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.CREATE:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigateByUrl("inventory/requisitions/exclusion/update");
            break;
        }
        break;
      case CrudType.VIEW:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(["inventory/requisitions/exclusion/view"], { queryParams: { id: editableObject['exclusionListId'] } });
            break;
        }
    }
  }
  exportList(pageIndex?: any, pageSize?: any, otherParams?: object) {
    let queryParams;
    queryParams = this.generateQueryParams(otherParams, pageIndex, pageSize);
    this.crudService.downloadFile(ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.EXCLUSION_LIST_EXPORT, null, null, queryParams).subscribe((response: any) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (response) {
          this.saveAsExcelFile(response, 'Exclusion Report');
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }
  generateQueryParams(queryParams, pageIndex, pageSize) {
    pageIndex = 0;
    let queryParamsString;
    queryParamsString = new HttpParams({ fromObject: this.otherParams })
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize);

    queryParamsString.toString();
    return queryParamsString;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  createExclusionFilterForm() {
    this.exclusionFilterForm = this._fb.group({
      warehouseIds: [''],
      fromDate: [''],
      toDate: [''],
    });
    // Subscribe to fromDate changes to clear toDate if fromDate becomes greater than toDate
    this.exclusionFilterForm.get('fromDate').valueChanges.subscribe((fromDate: Date) => {
      if (fromDate) {
        const toDateControl = this.exclusionFilterForm.get('toDate');
        if (toDateControl.value && toDateControl.value < fromDate) {
          toDateControl.setValue(null);
        }
      }
    });
  }

  submitFilter() {
    let filteredData = Object.assign({},
      { warehouseIds: this.exclusionFilterForm.get('warehouseIds').value ? this.exclusionFilterForm.get('warehouseIds').value : '' },
      { fromDate: this.exclusionFilterForm.get('fromDate').value ? this.momentService.localToUTC(this.exclusionFilterForm.get('fromDate').value) : "" },
      { toDate: this.exclusionFilterForm.get('toDate').value ? this.momentService.localToUTC(this.exclusionFilterForm.get('toDate').value) : '' },
      { UserId: this.loggedInUserData?.userId }
    );
    Object.keys(filteredData).forEach(key => {
      if (filteredData[key] === "" || filteredData[key].length == 0) {
        delete filteredData[key]
      }
    });
    let filterdNewData = Object.entries(filteredData).reduce((a, [k, v]) => (v == null ? a : (a[k] = v, a)), {}) //Filter all falsy values ( null, undefined )

    this.observableResponse = this.getRequiredListData('', '', filterdNewData);

    this.showFilterForm = !this.showFilterForm;
  }

  resetForm() {
    this.exclusionFilterForm.reset()
    this.observableResponse = this.getRequiredListData();
    this.showFilterForm = !this.showFilterForm;
  }

  onTabChange(event) {
    this.row = {}
    this.dataList = [];
    this.totalRecords = null;
    this.selectedTabIndex = event.index
    this.router.navigate(['/inventory/requisitions/exclusion'], { queryParams: { tab: this.selectedTabIndex } })
    this.getRequiredListData()
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet((this.selectedRows.length > 0) ? this.selectedRows : this.dataList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFileOld(excelBuffer, this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption);
    });
  }

  saveAsExcelFileOld(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  
  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
}

